import makeApiCall from "../master/axiosIndex";

const RABillApis = {
  listRABill: (params: any) =>
    makeApiCall({
      url: "/ra-bill/list",
      method: "get",
      params,
    }),
  approveRABill: (data: any) =>
    makeApiCall({
      url: "/ra-bill/approve",
      method: "post",
      data,
    }),
  rejectRABill: (data: any) =>
    makeApiCall({
      url: "/ra-bill/reject",
      method: "post",
      data,
    }),
  getRABillById: (raBillId: any) =>
    makeApiCall({
      url: `/ra-bill/id/${raBillId}`,
      method: "get",
    }),
};

export default RABillApis;
